import { useEffect } from 'react';
import { fetchCart, updateCart } from '../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ICartState } from '../redux/reducer';
import useNewC4Journey from 'hooks/useNewC4Journey';

const useCart = (isFetch = true): ICartState => {
  const cart = useSelector((state: { cart: ICartState }) => state.cart);
  const miniCart = useSelector((state: { miniCart: { updatedCart?: any } }) => state.miniCart);
  const dispatch = useDispatch();
  const isNewC4Journey = useNewC4Journey();

  if (miniCart.updatedCart && !isNewC4Journey) {
    updateCart(dispatch, miniCart.updatedCart);
  }

  // useLayoutEffect: make sure the API call gets triggred immediately
  // without waiting for the DOM
  // useLayoutEffect(() => {
  //   if (isFetch) {
  //     dispatch(fetchCart());
  //   }
  // }, [isFetch, dispatch]);
  useEffect(() => {
    if (isFetch) {
      dispatch(fetchCart());
    }
  }, [isFetch, dispatch]);

  return cart;
};

export default useCart;
